import React from 'react';
import {connect} from 'react-redux'
import PreferenceRowEdit from './PreferenceRowEdit'

import {
//   lock_account,
//   activate_account,
//   destroy_account,
  reset_preference_errors
} from '../actions'

const mapDispatchToProps = dispatch => {
  return {
    resetErrors: () => dispatch( reset_preference_errors() )
  }
}

class ConnectedPreferenceRow extends React.Component {

  initEdit() {
    const {id} = this.props.preference
    this.props.resetErrors()
    this.props.initEdit(id)
  }

  cancel() {
    this.props.initEdit(null)
  }

  render() {
    const {preference, currentEdit } = this.props
    const {id, name, value, datatype } = preference;

    const editLink = (
      <a href="" className="action-btn" title="Edit" onClick={ e=> {
        e.preventDefault()
        this.initEdit()
      }}><i className="material-icons tiny c-light-green">create</i></a>
    )

    const showRow  = (currentEdit !== id) ? "" : "hide"
    const showForm = (currentEdit === id) ? "" : "hide"

    return (
      <React.Fragment>
        <tr className={showRow}>
          <td className="padRight">
            <div className="view">{ name }</div>
          </td>
          <td title={`This value is ${datatype}`}>
            { value }
          </td>
          <td className="setToRight">
            { editLink }
          </td>
        </tr>

        <PreferenceRowEdit preference={preference} showForm={showForm} cancel={this.cancel.bind(this)}/>

      </React.Fragment>
    )

  }
}

const PreferenceRow = connect(null, mapDispatchToProps)(ConnectedPreferenceRow)

export default PreferenceRow



// WEBPACK FOOTER //
// ./src/js/components/PreferenceRow.js